import React, { useState } from "react";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";

import KeywordSearch from "../../../../sharedComponents/keywordSearch";
import { sortItemList } from "../../../../constants/recipeConstants";
import { resetField } from "../../../../store/actions";
import Tooltip from "../../../../sharedComponents/tooltip";

const RecipesHeader = ({ sortBy, toggleAdvancedFilterPanel, recipes, resetField, approveBtn, history, isApprovalListing, onDropdownSelect }) => {
	const setSortNav = (navItem) => {
		sortItemList.map((item) => {
			const sort = item === navItem ? (item.sort === "-asc" ? "-desc" : item.sort === "-desc" ? "-asc" : "-asc") : "";
			return (item.sort = sort);
		});
		const { field, sort, sortReverse } = sortItemList.filter((item) => {
			return item.sort === "-asc" || item.sort === "-desc";
		})[0];
		const queryString = sortReverse ? `${sort === "-desc" ? "" : "-"}${field}` : `${sort === "-desc" ? "-" : ""}${field}`;
		sortBy(queryString);
	};

	const [show, setShow] = useState(false);
	const [search, setSearch] = useState(false);

	const dropdownClick = (path) => {
		history.push(path);
		setShow(false);
		onDropdownSelect();
		setSearch(!search);
		resetField("Recipes.recipesSearchKeyword", "");
	}

	return (
		<div className="table-header pt-0">
			{approveBtn && approveBtn.show && approveBtn.toggle ? (
				<h3 className="flex-fill m-0">Recipe Submissions</h3>
			) : (
					<h3 className="flex-fill m-0">Most Viewed : Search Recipes</h3>
				)}
			{approveBtn && approveBtn.show ? (
				<Dropdown drop="down" show={show} className="approve-btn mr-2">
					<Dropdown.Toggle disabled={!recipes.length} onClick={() => setShow(!show)} className="btn btn-primary-dark btn-ghost mr-2">
						Patient Submissions
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<ul className="menu-list">
							{isApprovalListing ? (
								<li onClick={() => dropdownClick("/nutrition/recipes")}>Recipe Listing</li>
							) : (
									<li onClick={() => dropdownClick("/nutrition/recipes/approval")}>Recipe Approval</li>
								)}
							<li onClick={() => dropdownClick("/nutrition/recipes/comments")}>Comments</li>
						</ul>
					</Dropdown.Menu>
				</Dropdown>
			) : null}
			<KeywordSearch
				placeholder="Search Recipes"
				searchField="search"
				searchAction={(event) => {
					resetField("Recipes.recipesSearchKeyword", event ? event : "");
				}}
				name="searchRecipe"
				className="mr-2"
				reset={search}
			/>
			{isApprovalListing ? null : (
				<React.Fragment>
					<Tooltip content="Sort">
						<Dropdown drop="down" className="sort-recipe-dropdown">
							<Dropdown.Toggle
								disabled={!recipes.length}
								className="btn btn-primary-dark btn-ghost btn-icon mr-2">
								<i className="icon icon-transit" />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<ul className="sort-nav-list">
									{sortItemList.map((item, index) => {
										return (
											<li key={index} className="sort-nav" onClick={() => setSortNav(item)}>
												<i className={`icon icon-sort${item.sort}`} />
												{item.name}
											</li>
										);
									})}
								</ul>
							</Dropdown.Menu>
						</Dropdown>
					</Tooltip>
					<Tooltip content="Filter">
						<button className="btn btn-primary-dark btn-ghost btn-icon" onClick={toggleAdvancedFilterPanel}>
							<i className="icon icon-filter" />
						</button>
					</Tooltip>
				</React.Fragment>
			)}
		</div>
	);
};

const mapDispatchToProps = { resetField };

export default connect(
	null,
	mapDispatchToProps
)(RecipesHeader);
